export var stopLoadingsPlugin = function (router) { return ({
    onTransitionSuccess: function () {
        var _a = router.getDependencies(), stopLoadingActionsAfterNavigate = _a.stopLoadingActionsAfterNavigate, store = _a.store;
        if (!stopLoadingActionsAfterNavigate) {
            return;
        }
        // eslint-disable-next-line no-restricted-syntax
        for (var key in stopLoadingActionsAfterNavigate) {
            store.dispatch(stopLoadingActionsAfterNavigate[key]());
            delete stopLoadingActionsAfterNavigate[key];
        }
    },
}); };
